module.exports = __webpack_public_path__ + "9e8f8dc916b26230e0a7e3e8e51b12b5.svg";